const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;
const { MediaUpload, InspectorControls } = wp.blockEditor;
const { useSelect } = wp.data;
const {
	Button,
	TextControl,
	Panel,
	PanelBody,
	PanelRow,
	Icon,
	ColorPalette,
	ButtonGroup,
	SelectControl,
	ComboboxControl,
} = wp.components;
const { serverSideRender: ServerSideRender } = wp;
import { useState } from "react";

const { __experimentalLinkControlSearchInput: LinkControlSearchInput } =
	wp.blockEditor;

registerBlockType(
	"qteblocks/rolling-banner",
	{
		title: "Rullande banner",
		description: "En rullande banner med länkar",
		icon: "minus", // Icon, from WP icons
		category: "qteblocks",

		attributes: {},

		edit(props) {

			return (
				<>
					<InspectorControls>
						
					</InspectorControls>
					<ServerSideRender
						block="qteblocks/rolling-banner"
						attributes={props.attributes}
					/>
				</>
			);
		},

		save(props) {
			return null; // See PHP side. This block is rendered on PHP.
		},
	},
);
